import { Alert, Button, Container, Stack, Typography } from '@mui/material'
import { useState } from 'preact/hooks'
import { useLocation } from 'preact-iso'
import { api } from '../api/client'
import type { EventDetails } from '../api/generated/EventDetails'
import type { NewEvent } from '../api/generated/NewEvent'
import { useAction } from '../api/useAction'
import { useSession } from '../auth/session'
import {
  defaultSettings,
  EventSettingsFields,
  type SettingsForm,
} from '../events/EventSettingsFields'
import { SlugField, useSlug } from '../events/SlugField'

const creationForbidden =
  "La création d'événements est réservée aux personnes autorisées par un administrateur."

export function EventNew() {
  const { me } = useSession()
  const { route } = useLocation()
  const [settings, setSettings] = useState<SettingsForm>(defaultSettings)
  const [slug, setSlug] = useSlug(settings.name)
  const { error, pending, run } = useAction({ forbidden: creationForbidden })

  const submit = (event: Event) => {
    event.preventDefault()
    run(async () => {
      const body: NewEvent = { ...settings, slug, applications_open: false }
      const created = await api.post<EventDetails>('/events', body)
      route(`/events/${created.slug}`)
    })
  }

  if (!me?.can_create_events)
    return (
      <Alert severity="info" sx={{ m: 4 }}>
        {creationForbidden}
      </Alert>
    )

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Nouvel événement
      </Typography>
      <Stack component="form" spacing={2} onSubmit={submit}>
        <EventSettingsFields value={settings} datesRequired onChange={setSettings} />
        <SlugField value={slug} onChange={setSlug} />
        {error && <Alert severity="error">{error}</Alert>}
        <Button type="submit" variant="contained" size="large" loading={pending}>
          Créer l'événement
        </Button>
      </Stack>
    </Container>
  )
}
